(function () {
  function initCarousel(root) {
    if (!root || root.dataset.jhpCarouselReady === 'true') return;

    var track = root.querySelector('[data-jhp-track]');
    if (!track) return;

    root.dataset.jhpCarouselReady = 'true';

    var prev = root.querySelector('[data-jhp-prev]');
    var next = root.querySelector('[data-jhp-next]');
    var thumb = root.querySelector('[data-jhp-thumb]');
    var progress = root.querySelector('[data-jhp-progress]');
    var thumbInset = 0;

    function getStep() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    }

    function updateProgress() {
      if (!thumb || !progress) return;

      var cards = Array.from(track.querySelectorAll(':scope > *'));
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var totalWidth = cards.reduce(function (sum, card) {
        return sum + card.getBoundingClientRect().width;
      }, 0) + Math.max(0, cards.length - 1) * gap;
      var maxScroll = Math.max(0, totalWidth - track.clientWidth);
      var trackWidth = progress.clientWidth;

      if (trackWidth <= 0) return;

      if (maxScroll <= 0) {
        thumb.style.width = Math.max(0, trackWidth) + 'px';
        thumb.style.transform = 'translateX(0)';
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;

      var thumbWidth = Math.min(
        Math.max(36, (track.clientWidth / totalWidth) * trackWidth),
        Math.max(0, trackWidth - thumbInset * 2)
      );
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var maxOffset = Math.max(0, trackWidth - thumbWidth - thumbInset * 2);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (thumbInset + Math.max(0, Math.min(maxOffset, ratio * maxOffset))) + 'px)';
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        scrollByDir(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        scrollByDir(1);
      });
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    window.addEventListener('load', updateProgress);

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(updateProgress);
      resizeObserver.observe(track);
      if (progress) resizeObserver.observe(progress);
    }

    root.addEventListener('jhp:panel-active', updateProgress);
    updateProgress();
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-jhp-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
